<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        categoryId: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            includeHeader: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                parentCategoryId: this.categoryId
            };
        },

        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Created by',
                    value: 'createdBy.fullName',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Edited by',
                    value: 'editedBy.fullName',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'articleCategories/getSubcategories',
            deleteItem: 'articleCategories/destroy'
        }),

        onRowClick({ id, parentCategoryId }) {
            this.$router.push(
                `/article-categories/${parentCategoryId}/subcategories/${id}/edit`
            );
        },

        onAddButtonClick() {
            this.$router.push(
                `/article-categories/${this.categoryId}/subcategories/add`
            );
        }
    }
};
</script>
